import { render, staticRenderFns } from "./TableRowComponent.vue?vue&type=template&id=32cb0e04&"
import script from "./TableRowComponent.vue?vue&type=script&lang=js&"
export * from "./TableRowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports